import React, { Component } from 'react';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import Formatter from '../../utils/Formatter';
import AnalysisTools from '../../utils/AnalysisTools';
import NestedLoanBreakdown from './NestedLoanBreakdown';


class SingleLoanGroup extends Component {

    state = {
        expanded: false,
    }

    toggleExpansion = () => {
        this.setState({ expanded: !this.state.expanded });
    };


    render() {
        const { loan, account, recommendedPlan } = this.props;
        return (
            <>
                <TableRow key={loan.id}>
                    <TableCell colSpan={2}>{loan.type.name}</TableCell>
                    <TableCell>${Formatter.money(loan.balance)}</TableCell>
                    <TableCell>{Formatter.statusText(loan.status)}</TableCell>
                    <TableCell>{Formatter.repaymentPlanText(loan.plan)}</TableCell>
                    <TableCell>{Formatter.money(loan.loanInterestRate)}%</TableCell>
                    <TableCell>${Formatter.money(loan.mmp)}</TableCell>
                    <TableCell>{Formatter.repaymentPlanText(recommendedPlan)}</TableCell>
                    {loan.nestedLoans && <NavigateNextIcon
                        onClick={this.toggleExpansion}
                        className={`navigate-next ${this.state.expanded ? 'opened' : ''
                            }`}
                    />}
                </TableRow>
                {this.state.expanded && loan.nestedLoans && loan.nestedLoans.map(item => (
                    <NestedLoanBreakdown loan={item} account={account} recommendedPlan={recommendedPlan} />
                ))}
            </>

        )
    }
}


export default SingleLoanGroup;